var PublicDashboardComponents;
(function (PublicDashboardComponents) {
    PublicDashboardComponents["LAST_MEASUREMENTS"] = "LastMeasurement";
    PublicDashboardComponents["CHART"] = "RecentGraph";
    PublicDashboardComponents["REPORTS"] = "Reports";
    PublicDashboardComponents["ANNOTATIONS"] = "Annotations";
    PublicDashboardComponents["ALLOW_GENERATE_REPORT"] = "AllowGenerateReport";
})(PublicDashboardComponents || (PublicDashboardComponents = {}));
export default PublicDashboardComponents;
